import { Flex, Typography } from '@aloft/toolkit-sui';

type UploadDocumentsFieldProps = React.PropsWithChildren<{
  id: string;
  label: string;
  required?: boolean;
}>;

// HACK: This steals the required asterisk from `<SimpleFormWrapper>`.
// Ideally, we'd add `<FileUploader>` to SUI and have it accept all the
// form control props that our other `<Simple*>` inputs accept.
export const UploadDocumentsField = ({
  id,
  label,
  required,
  children,
}: UploadDocumentsFieldProps) => (
  <Flex flexDirection="column" flexBasis="300px" height="180px">
    <label htmlFor={id} className="simple-field-label">
      <Typography variant="label">{label}</Typography>
      {required && <span className="simple-field-required">*</span>}
    </label>
    {children}
  </Flex>
);
